﻿import dimbox from 'dimbox';

document.addEventListener('DOMContentLoaded', () => {
    dimbox.setConfig({
        showDownloadButton: false,
        iframeTemplate:	'<div class= "dimbox-iframe-container" ><iframe src="{{src}}" class="dimbox-iframe" allow="autoplay; encrypted-media" allowfullscreens></iframe><div class="dimbox-caption">{{caption}}</div></div>'
    });
});